import React from 'react';
import { useAchievements } from '../../Context/AchievementsProvider';
import { AchievementTier } from '../../Types/AchievementTier';

interface AchievementProgressBarProps {
  progress: number;
  tier: AchievementTier;
}

export const AchievementProgressBar: React.FC<AchievementProgressBarProps> = ({
  progress,
  tier,
}) => {
  const { getTierColor } = useAchievements();
  const tierColor = getTierColor(tier);
  return (
    <div
      className="w-full h-2.5 rounded-full overflow-hidden"
      style={{ backgroundColor: `${tierColor}60` }} // 60 is hex for 37% opacity
    >
      <div
        className="h-full rounded-full transition-all duration-300"
        style={{
          width: `${progress}%`,
          backgroundColor: tierColor,
        }}
      />
    </div>
  );
};
